import { render, staticRenderFns } from "./BangTongHopPhieuThuTien.vue?vue&type=template&id=3598f3e2"
import script from "./BangTongHopPhieuThuTien.vue?vue&type=script&lang=js"
export * from "./BangTongHopPhieuThuTien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports